import React from 'react';
import cx from 'classnames';

import FeaturedBaseView from './FeaturedBaseView';

const FeaturedH2View = (props) => {
  return (
    <FeaturedBaseView
      {...props}
      HeadingTag="h2"
      headerSize="big"
      animatedHeading={true}
      className={cx('featured-h2', props.className)}
      buttons="true"
    />
  );
};

export default FeaturedH2View;
